webpackJsonp([1],{

/***/ "1ENH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"board"}},_vm._l((_vm.board),function(row,rowNum){return _c('div',_vm._l((row),function(brick,colNum){return _c('div',{staticClass:"brick",style:({ backgroundColor: brick.color}),on:{"click":function($event){_vm.pop(rowNum, colNum)}}})}))})),_vm._v(" "),_c('div',{attrs:{"id":"options"}},[_c('div',[_vm._v("\n      High Score: "),_c('span',[_vm._v(_vm._s(_vm.highScore))])]),_vm._v(" "),_c('div',{attrs:{"id":"score"}},[_vm._v("\n      Score: "),_c('span',[_vm._v(_vm._s(_vm.score))])]),_vm._v(" "),_c('div',{attrs:{"id":"reset-btn"},on:{"click":_vm.onReset}},[_vm._v("\n      Reset\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FQIG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57db4a67_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("1ENH");
function injectStyle (ssrContext) {
  __webpack_require__("FQIG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57db4a67_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// white red blue yellow green purple grey
var colors = ['#ffffff', '#FFCDD2', '#C5CAE9', '#FFF9C4', '#C8E6C9', '#D1C4E9'];
var blankBrick = { type: 0, color: colors[0] };
var localStorageKey = 'vbp-high-score';
var poppedBricks = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      board: [[], [], [], [], [], [], [], [], [], []],
      currentColors: [1, 2, 3],
      poppedRange: {},
      highScore: localStorage.getItem(localStorageKey) || 0,
      score: 0
    };
  },
  created: function created() {
    this.initBoard();
  },

  methods: {
    initBoard: function initBoard() {
      for (var i = 0; i < 10; i++) {
        for (var j = 0; j < 10; j++) {
          var color = Math.floor(Math.random() * this.currentColors.length);
          this.board[i].splice(j, 1, {
            type: this.currentColors[color],
            color: colors[this.currentColors[color]]
          });
        }
      }
      console.log(this.board);
    },
    pop: function pop(rowNum, colNum) {
      var top = this.board[rowNum - 1] ? this.board[rowNum - 1][colNum].type : null;
      var bottom = this.board[rowNum + 1] ? this.board[rowNum + 1][colNum].type : null;
      var right = this.board[rowNum][colNum + 1] ? this.board[rowNum][colNum + 1].type : null;
      var left = this.board[rowNum][colNum - 1] ? this.board[rowNum][colNum - 1].type : null;
      var brickType = this.board[rowNum][colNum].type;

      // only allow pop if brick isn't popped and theres a matching brick near selected brick
      if (brickType !== 0 && (brickType === top || brickType === bottom || brickType === right || brickType === left)) {
        poppedBricks = 0;
        this.poppedRange = {};
        this.poppedRange[colNum] = rowNum;
        this.traversePop(rowNum, colNum, brickType);
        this.dropBricks();
        this.slideBricks();
        this.score += poppedBricks * poppedBricks;
        // new high score
        if (this.score > this.highScore) {
          this.highScore = this.score;
          localStorage.setItem(localStorageKey, this.highScore);
        }
        this.checkStatus();
      }
    },

    // recursively pops bricks of the same type
    traversePop: function traversePop(rowNum, colNum, initType) {
      // replace popped brick with blank brick
      this.board[rowNum].splice(colNum, 1, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, blankBrick));

      // increment popped brick count
      poppedBricks += 1;

      // recursive pop same color bricks from top, bottom, right, left
      var top = this.board[rowNum - 1] ? this.board[rowNum - 1][colNum].type : null;
      if (top === initType) this.traversePop(rowNum - 1, colNum, initType);

      var bottom = this.board[rowNum + 1] ? this.board[rowNum + 1][colNum].type : null;
      if (bottom === initType) this.traversePop(rowNum + 1, colNum, initType);

      var right = this.board[rowNum][colNum + 1] ? this.board[rowNum][colNum + 1].type : null;
      if (right === initType) this.traversePop(rowNum, colNum + 1, initType);

      var left = this.board[rowNum][colNum - 1] ? this.board[rowNum][colNum - 1].type : null;
      if (left === initType) this.traversePop(rowNum, colNum - 1, initType);

      // new row
      if (this.poppedRange[colNum] === undefined) {
        this.poppedRange[colNum] = rowNum;
      } else if (this.poppedRange[colNum] !== undefined && this.poppedRange[colNum] < rowNum) {
        this.poppedRange[colNum] = rowNum;
      }
    },

    // recursively moves bricks down if space is empty
    dropBricks: function dropBricks() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.poppedRange).forEach(function (colNum) {
        // loop through columns of popped bricks
        for (var rowNum = _this.poppedRange[colNum] - 1; rowNum >= 0; rowNum--) {
          // if it's not blank brick and below is blank brick
          if (_this.board[rowNum][colNum].type !== 0 && _this.board[rowNum + 1] !== undefined && _this.board[rowNum + 1][colNum].type === 0) {
            // move brick down one column
            _this.board[rowNum + 1].splice(colNum, 1, _this.board[rowNum][colNum]);
            _this.board[rowNum].splice(colNum, 1, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, blankBrick));
            _this.dropBricks();
          }
        }
      });
    },

    // recursively slide bricks left if column is empty
    slideBricks: function slideBricks() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.poppedRange).reverse().forEach(function (key) {
        var colNum = parseInt(key, 10);

        // last brick in column is empty means column is empty
        if (_this2.board[9][colNum].type === 0) {
          // from empty column to last column
          for (var i = colNum; i < _this2.board[9].length - 1; i++) {
            var col = [];
            // get the column
            for (var j = 0; j < _this2.board.length; j++) {
              col.push(_this2.board[j][i + 1]);
            }
            // copy next column to current column
            for (var k = 0; k < _this2.board.length; k++) {
              _this2.board[k].splice(i, 1, col[k]);
              _this2.board[k].splice(i + 1, 1, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, blankBrick));
            }
          }
        }
      });
    },
    onReset: function onReset() {
      this.initBoard();
      this.score = 0;
    },
    checkStatus: function checkStatus() {
      // winning condition - brick on last row first column is empty
      if (this.board[9][0].type === 0) {
        // add new color if possible
        if (this.currentColors.length < colors.length - 1) {
          this.currentColors.push(this.currentColors.length + 1);
        }
        this.initBoard();
        return true;
      }

      // reset game on loss
      if (this.checkLoss(9, 0)) {
        this.onReset();
      }

      return false;
    },
    checkLoss: function checkLoss(rowNum, colNum) {
      var brickType = this.board[rowNum][colNum].type;
      // base statement - empty brick
      if (brickType === 0) {
        return true;
      }

      var top = this.board[rowNum - 1] ? this.board[rowNum - 1][colNum].type : null;
      var right = this.board[rowNum][colNum + 1] ? this.board[rowNum][colNum + 1].type : null;
      var topCheck = true;
      var rightCheck = true;

      if (top === brickType || right === brickType) {
        return false;
      }

      if (top !== null) topCheck = this.checkLoss(rowNum - 1, colNum);
      if (topCheck === false) return topCheck;

      if (right !== null) rightCheck = this.checkLoss(rowNum, colNum + 1);
      if (rightCheck === false) return rightCheck;

      return true;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.205be376fac3b430131a.js